import React, { Component } from 'react';
import PropertySelect from './PropertySelect';
import { Typography, Grid } from '@material-ui/core';
import { PropertyFilter, CategoryFilter } from '../../../models/SearchFilter';
import { ProductProp } from '../../../models/ProductProp';

type Props = {
    defaultValue: string,
    properties: ProductProp[],
    appliedPropertyFilters: PropertyFilter[],
    replaceFilter: (categoryFilter?: CategoryFilter | null, propertyFilter?: PropertyFilter| null) => void,
    replaceFilter2?: (property: ProductProp) => void
}

class ProductProperties extends Component<Props> {
    render() {
        return (
            <div>
                {this.props.properties.length > 0 &&
                    <div style={{ textAlign: 'left' }}>
                        <Grid container style={{ paddingTop: '5px' }}>
                                <Grid container>
                                    {this.props.properties.map((prop, i) => {
                                        return (
                                            <Grid item  xs={12} sm key={i} style={{minWidth:'110px'}} > 
                                                <PropertySelect
                                                    defaultValue={this.props.defaultValue}
                                                    replaceFilter={this.props.replaceFilter} 
                                                    replaceFilter2={this.props.replaceFilter2}
                                                    prodProp={prop} 
                                                    appliedPropertyFilters={this.props.appliedPropertyFilters.filter((apf) => apf.propId === prop.id)}></PropertySelect>
                                            </Grid>
                                        )
                                    })}
                                </Grid>
                        </Grid>
                    </div>
                }
            </div>
        )
    }
}

export default ProductProperties